module.exports = __webpack_public_path__ + "static/media/avatar_23.556c5a0f.svg";